import { useCallback } from 'react'
import Skeleton from 'react-loading-skeleton'
import type { MealPeriodTab } from '~/lib/mealPeriod/tab'
import { tabIcons } from '~/lib/mealPeriod/tab'
import { useSendClickEvent } from '~/navigation'
import {
  useCalendarQueryStatus,
  useChangeMealPeriod,
  useMealPeriod,
  useMealPeriods,
} from '~/stores/calendar/state'
import { createTabs } from '~/ui/Tabs'

const Tabs = createTabs<MealPeriodTab>()

export function MealPeriodTab() {
  const { selectedTab, tabs, onClick } = useMealPeriodSelection()
  const status = useCalendarQueryStatus()
  if (status === 'pending') {
    return <Skeleton height={41} />
  }
  if (status === 'error') {
    throw new Error('カレンダー情報を取得できませんでした。')
  }
  return (
    <Tabs.Root value={selectedTab} theme="meal-period">
      {tabs.map((tab) => (
        <Tabs.Tab key={tab.value} value={tab.value} onClick={onClick} Icon={tabIcons[tab.value]}>
          {tab.label}
        </Tabs.Tab>
      ))}
    </Tabs.Root>
  )
}

function useMealPeriodSelection() {
  const selectedTab = useMealPeriod()
  const tabs = useMealPeriods()
  const changeTab = useChangeMealPeriod()
  const sendClickEvent = useSendClickEvent()
  const onClick = useCallback(
    (tab: MealPeriodTab) => {
      sendClickEvent({
        inventoryCalendar: 'mealPeriod',
        click_event: 'newReservationFlow/inventoryCalendar/mealPeriod',
      })

      changeTab(tab)
    },
    [changeTab, sendClickEvent]
  )
  return { selectedTab, tabs, onClick }
}
